module.exports = __webpack_public_path__ + "static/media/filters-dark.e02c737f.svg";